<template>
  <h1>Deleted booking supplier page</h1>
</template>

<script></script>
